var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Paper, Grid, Typography, Divider } from "@material-ui/core";
import { createStyles, withStyles } from '@material-ui/core/styles';
import { format, differenceInCalendarMonths } from "date-fns";
import ArrowRightAlt from "@material-ui/icons/ArrowRightAlt";
import Month from "./Month";
import DefinedRanges from "./DefinedRanges";
import { MARKERS } from "../markers";
var styles = function (theme) {
    return createStyles({
        header: {
            padding: "20px 70px"
        },
        headerItem: {
            flex: 1,
            textAlign: "center"
        },
        divider: {
            borderLeft: "1px solid " + theme.palette.action.hover,
            marginBottom: 20
        }
    });
};
var Menu = function (props) {
    var classes = props.classes, ranges = props.ranges, dateRange = props.dateRange, minDate = props.minDate, maxDate = props.maxDate, firstMonth = props.firstMonth, setFirstMonth = props.setFirstMonth, secondMonth = props.secondMonth, setSecondMonth = props.setSecondMonth, setDateRange = props.setDateRange, helpers = props.helpers, handlers = props.handlers, translation = props.translation;
    var translationText = __assign({
        startDate: "Start Date",
        endDate: "End Date"
    }, translation);
    var startDate = dateRange.startDate, endDate = dateRange.endDate;
    var canNavigateCloser = differenceInCalendarMonths(secondMonth, firstMonth) >= 2;
    var commonProps = { dateRange: dateRange, minDate: minDate, maxDate: maxDate, helpers: helpers, handlers: handlers };
    return (React.createElement(Paper, { elevation: 5, square: true },
        React.createElement(Grid, { container: true, direction: "row", wrap: "nowrap" },
            React.createElement(Grid, null,
                React.createElement(Grid, { container: true, className: classes.header, alignItems: "center" },
                    React.createElement(Grid, { item: true, className: classes.headerItem },
                        React.createElement(Typography, { variant: "subtitle1" }, startDate ? format(startDate, "MMMM dd, yyyy", { locale: translation === null || translation === void 0 ? void 0 : translation.locale }) : translationText === null || translationText === void 0 ? void 0 : translationText.startDate)),
                    React.createElement(Grid, { item: true, className: classes.headerItem },
                        React.createElement(ArrowRightAlt, { color: "action" })),
                    React.createElement(Grid, { item: true, className: classes.headerItem },
                        React.createElement(Typography, { variant: "subtitle1" }, endDate ? format(endDate, "MMMM dd, yyyy", { locale: translation === null || translation === void 0 ? void 0 : translation.locale }) : translationText === null || translationText === void 0 ? void 0 : translationText.endDate))),
                React.createElement(Divider, null),
                React.createElement(Grid, { container: true, direction: "row", justify: "center", wrap: "nowrap" },
                    React.createElement(Month, __assign({}, commonProps, { value: firstMonth, setValue: setFirstMonth, navState: [true, canNavigateCloser], marker: MARKERS.FIRST_MONTH, weekDays: translationText === null || translationText === void 0 ? void 0 : translationText.weekDays, months: translationText === null || translationText === void 0 ? void 0 : translationText.months })),
                    React.createElement("div", { className: classes.divider }),
                    React.createElement(Month, __assign({}, commonProps, { value: secondMonth, setValue: setSecondMonth, navState: [canNavigateCloser, true], marker: MARKERS.SECOND_MONTH, weekDays: translationText === null || translationText === void 0 ? void 0 : translationText.weekDays, months: translationText === null || translationText === void 0 ? void 0 : translationText.months })))),
            React.createElement("div", { className: classes.divider }),
            React.createElement(Grid, null,
                React.createElement(DefinedRanges, { selectedRange: dateRange, ranges: ranges, setRange: setDateRange })))));
};
export default withStyles(styles)(Menu);
//# sourceMappingURL=Menu.js.map